import './style.css';
import type { Manifest } from './contracts.ts';
import { viewerParameters } from './parameters.ts';

const params = viewerParameters();
if (params.get('embed') === '1') document.documentElement.classList.add('embed');
const button = document.getElementById('start') as HTMLButtonElement;
let starting = false;
async function start(): Promise<void> {
  if (starting) return; starting = true; button.disabled = true;
  const panel = document.getElementById('start-panel')!, loading = document.getElementById('loading')!;
  panel.hidden = true; loading.hidden = false;
  try {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('webgl2');
    if (!context) throw new Error('WEBGL_UNAVAILABLE');
    context.getExtension('WEBGL_lose_context')?.loseContext();
    const modelUrl = new URL('./model/', document.baseURI);
    const [response, module] = await Promise.all([fetch(new URL('manifest.json', modelUrl)), import('./viewer.ts')]);
    if (!response.ok) throw new Error('MODEL_UNAVAILABLE');
    const manifest = await response.json() as Manifest;
    if (!manifest.tiles?.length || !manifest.boundary?.length || !manifest.origin || !manifest.bounds) throw new Error('MODEL_UNAVAILABLE');
    const viewer = new module.Viewer(manifest, modelUrl); await viewer.start();
  } catch (error) {
    loading.hidden = true; panel.hidden = false; panel.classList.add('error-panel'); panel.replaceChildren();
    const content = document.createElement('div'); content.className = 'start-content';
    const title = document.createElement('h2'); title.textContent = (error as Error).message === 'WEBGL_UNAVAILABLE' ? '3D is unavailable in this browser' : 'The Austin model is unavailable';
    const message = document.createElement('p'); message.textContent = (error as Error).message === 'WEBGL_UNAVAILABLE' ? 'This viewer needs WebGL 2. Try a browser with hardware acceleration enabled, or continue with the site’s address and neighborhood pages.' : 'The local model files could not load. Serve the complete viewer folder over HTTP or HTTPS and try again.';
    const link = document.createElement('a'); link.href = '/neighborhood/'; link.textContent = 'Browse Austin neighborhoods';
    content.append(title, message, link); panel.append(content);
  }
}
button.addEventListener('click', () => { void start(); });
// Autostart is reserved for an iframe created after the parent page’s Start click.
if (params.get('embed') === '1' && params.get('autostart') === '1' && window.parent !== window) void start();
